/* The Detail Reserve — lead and call measurement.
   One event per real action: phone_click, text_click, generate_lead.
   Sends to Google only when turned on in theme settings, on the published theme, and with the
   visitor's consent (Shopify Customer Privacy). Otherwise events are only recorded in
   window.tdrEvents so they can be checked in preview. No names, phone numbers, emails or
   message text are ever sent. */
(() => {
  const el = document.getElementById('tdr-tracking');
  let cfg = {};
  try { cfg = JSON.parse(el ? el.textContent : '{}'); } catch (_) { /* bad config: stay dry */ }
  const events = (window.tdrEvents = window.tdrEvents || []);
  const live = Boolean(cfg.enabled && cfg.live && cfg.ga4);
  const consent = { analytics: false, marketing: false, known: false };
  let gtagLoaded = false;
  // Events from before Shopify has reported consent (e.g. a request confirmed right after page load)
  // wait here, then go out only if consent allows.
  const pending = [];

  const gtag = function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
  const state = (on) => (on ? 'granted' : 'denied');

  const readConsent = () => {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return;
    consent.analytics = Boolean(p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
    consent.marketing = Boolean(p.marketingAllowed && p.marketingAllowed());
    consent.known = true;
    if (gtagLoaded) gtag('consent', 'update', { analytics_storage: state(consent.analytics), ad_storage: state(consent.marketing), ad_user_data: state(consent.marketing), ad_personalization: state(consent.marketing) });
    if (live && consent.analytics && !gtagLoaded) loadGtag();
    pending.splice(0).forEach(send);
  };

  // Google forwarding numbers (Ads "calls from website"): only the displayed number and tel: links
  // change. Text links keep the real Google Voice number, because forwarding numbers can't take texts.
  const swapNumber = (formatted, mobile) => {
    document.querySelectorAll('[data-phone-display]').forEach((n) => { n.textContent = formatted; });
    document.querySelectorAll('a[href^="tel:"]').forEach((a) => { a.href = `tel:${mobile}`; });
  };

  function loadGtag() {
    gtagLoaded = true;
    window.gtag = window.gtag || gtag;
    gtag('consent', 'default', { analytics_storage: state(consent.analytics), ad_storage: state(consent.marketing), ad_user_data: state(consent.marketing), ad_personalization: state(consent.marketing) });
    // Shopify's Google & YouTube app already loads the Google tag on the page (and sends page views).
    // Reuse it; only load the library when nothing else has.
    if (![...document.scripts].some((x) => /googletagmanager\.com\/gtag\/js/.test(x.src))) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(cfg.ga4)}`;
      document.head.appendChild(s);
    }
    gtag('js', new Date());
    // Page views and purchases already come from Shopify's Google & YouTube app: never send them twice.
    gtag('config', cfg.ga4, { send_page_view: false });
    if (cfg.ads) {
      gtag('config', cfg.ads, { send_page_view: false });
      if (cfg.forwardingLabel && cfg.phone && consent.marketing) {
        gtag('config', `${cfg.ads}/${cfg.forwardingLabel}`, { phone_conversion_number: cfg.phone, phone_conversion_callback: swapNumber });
      }
    }
  }

  const zoneOf = (a) => {
    const t = a.dataset.track || '';
    if (t) { const z = t.replace(/^(call|text)_/, ''); return z === 'bar' ? 'sticky_mobile' : z; }
    const z = a.closest('header, footer, [data-bar], [data-est], .req, .hero, .home, .contact, section');
    if (!z) return 'other';
    if (z.matches('header')) return 'header';
    if (z.matches('footer')) return 'footer';
    if (z.matches('[data-bar], [data-est]')) return 'sticky';
    if (z.matches('.req')) return 'request_form';
    return 'page';
  };

  // Read-only view for checking the setup in preview (no personal data).
  window.tdrTrackState = () => ({ live, gtagLoaded, consent: { ...consent } });

  const lastSent = new WeakMap();
  window.tdrTrack = (name, params = {}) => {
    const ev = {
      name,
      params: { page_path: location.pathname, service_category: document.body.dataset.service || 'other', ...params },
      at: Date.now(),
      sent: { ga4: false, ads: false },
    };
    events.push(ev);
    if (live && !consent.known) pending.push(ev); else send(ev);
    return ev;
  };
  function send(ev) {
    if (live && gtagLoaded && consent.analytics) {
      gtag('event', ev.name, { ...ev.params, send_to: cfg.ga4 });
      ev.sent.ga4 = true;
    }
    const label = cfg.adsLabels && cfg.adsLabels[ev.name];
    if (live && gtagLoaded && consent.marketing && cfg.ads && label) {
      gtag('event', 'conversion', { send_to: `${cfg.ads}/${label}` });
      ev.sent.ads = true;
    }
  }

  // One listener for every call and text link on the site. A double-tap within 1.5 s counts once.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="tel:"], a[href^="sms:"]');
    if (!a) return;
    const now = Date.now();
    if (now - (lastSent.get(a) || 0) < 1500) return;
    lastSent.set(a, now);
    window.tdrTrack(a.href.startsWith('tel:') ? 'phone_click' : 'text_click', { button_location: zoneOf(a) });
  }, true);

  // Consent: read now, and again whenever the visitor changes it (accept, decline or withdraw).
  document.addEventListener('visitorConsentCollected', readConsent);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) readConsent(); });
  } else {
    readConsent();
  }
})();
